import React from 'react';
import { createRoot } from 'react-dom/client';
import FitGuideRacks from './FitGuideRacks';

const rootElement = document.getElementById('REACT_fitAssistantPDP');

const renderApp = () => {
  let fitGuideData = window._THULEDATA.FitGuideRacksData;

  if (rootElement) {
    let root = createRoot(rootElement);
    root.render(<FitGuideRacks data={fitGuideData} />);
  }
};

renderApp();
